/* Zeus Carbon Product Customizer 
---- List of Media IDs and settings for connected customizer
---- All Media IDs must be listed here and in snippets/media.liquid to work
---- When making new additions, be careful of comma placement and general syntax
*/

customizer_product = {
    /*--------------------- Default ---------------------*/
    default: {
      productName: "Default",
      backgroundOptions: {
        image: "",
        colorOptions: {
          0: {
            filter: "saturate(0%) brightness(180%)"
          },
          1: {
            filter: ""
          },
          2: {
            filter: "sepia(100%) saturate(300%) hue-rotate(-55deg)"
          },
          3: {
            filter: "sepia(100%) saturate(300%) hue-rotate(180deg)"
          },
          4: {
            filter: "sepia(100%) saturate(300%) hue-rotate(50deg)"
          },
          5: {
            filter: "sepia(100%) saturate(300%) hue-rotate(15deg)"
          }
        }
      },
      customOptions: {
        leatherColor: {
          image: "",
          image2: "",
          image3: "",
          triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/37940321c2a5a8dce0c01deff8c430fa.png",
          triggerImage2: "https://customizery.s3.amazonaws.com/bimmerfxx/3bc6562688e9e4d0b2528f62c7b566ea.png",
          triggerImage3: "https://customizery.s3.amazonaws.com/bimmerfxx/238acbfd68006cbbab392a21ea5b1988.png",
          imageTopBot: "",
          colorOptions: {
            0: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/ad4c058dc3dcb997c7d3d7ff45021fb7.png",
              filter: "sepia(100%) saturate(0%) hue-rotate(0deg) contrast(120%)"
            },
            1: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/bf821a51f44f02c560068ac646499725.png",
              filter: "sepia(100%) saturate(0%) hue-rotate(0deg) contrast(100%)"
            },
            2: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/021aba59ff2388322e955bfc31cf2970.png",
              filter: "sepia(100%) saturate(0%) hue-rotate(0deg) contrast(90%)"
            }, 
            3: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/c55705f37d6ab4740cc0ced17ec0ec9b.png",
              filter: "sepia(100%) saturate(400%) hue-rotate(-50deg)"
            },
            4: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/ff4eea4bc45240efbc24de34b5ed68c1.png",
              filter: "sepia(100%) saturate(0%) hue-rotate(0deg) contrast(110%)"
            },
            5: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/7e49ca127b036819f8b49cda81d13834.png",
              filter: "sepia(100%) saturate(600%) hue-rotate(-50deg)"
            },
            6: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/601491cf2bc48935ee7f1e46545f6501.png",
              filter: "sepia(100%) saturate(400%) hue-rotate(-30deg) brightness(150%)"
            },
            7: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/6b0e2960cebb985f4ae32efb4889f3ca.png",
              filter: "sepia(100%) saturate(0%) hue-rotate(0deg) brightness(160%)"
            },
            8: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/09acf5df0e8bd0dc66a17a6bfda4e3a2.png",
              filter: "sepia(100%) saturate(0%) hue-rotate(0deg) brightness(140%)"
            },
            9: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/8cf92c51c6bc419f73d08ec094c4ae4c.png",
              filter: "sepia(100%) saturate(200%) hue-rotate(340deg)"
            },
            10: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/bfbdea01ea31065ffc3fd188e6c9d481.png",
              filter: "sepia(100%) saturate(300%) hue-rotate(150deg) brightness(120%)"
            },
            11: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/d546346931ee5962fc1c6e5e7d9d84f3.png",
              filter: "sepia(100%) saturate(100%) hue-rotate(0deg) brightness(140%)"
            }
          }
        },
        carbonFiberStyle: {
          image: "",
          image2: "",
          colorOptions: {
            0: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/686db1266f7d9f9da1eaca69ce1b97e1.png",
              filter: "sepia(100%) saturate(0%) hue-rotate(0deg) contrast(90%) brightness(80%)"
            },
            1: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/3ee46fb157e06ffa9b0a321b54bcb39d.png",
              filter: "sepia(100%) saturate(0%) hue-rotate(0deg) contrast(90%) brightness(80%)"
            },
            2: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/47ad1a9efbca93dd7ad2d70bcbc15c0c.png",
              filter: "sepia(100%) saturate(0%) hue-rotate(0deg) contrast(90%) brightness(80%)"
            }, 
            3: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/2fd069fad793da188073e0d3a0e88216.png",
              filter: "sepia(100%) saturate(80%) hue-rotate(-50deg) contrast(120%)"
            },
            4: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/03b10054d186d77746e959965b7f77c3.png",
              filter: "sepia(100%) saturate(100%) hue-rotate(10deg)"
            },
            5: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/74f89f6ab3d6abbf6fd1b50df3b51b5d.png",
              filter: "sepia(100%) saturate(200%) hue-rotate(-60deg) brightness(80%) contrast(130%)"
            },
            6: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/3f48b9951e1904b84c6d16b3e84ae2b3.png",
              filter: "sepia(100%) saturate(400%) hue-rotate(-60deg) brightness(80%)"
            },
            7: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/6ac07c7326bc088f1aa1c87088870479.png",
              filter: "sepia(100%) saturate(400%) hue-rotate(140deg) brightness(160%)"
            },
            8: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/84b33dbfc6bd3e13c38b41395a65bf86.png",
              filter: "sepia(100%) saturate(0%) hue-rotate(0deg) brightness(230%)"
            },
            9: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/23ce787974b51e1719e8ae9cfc278fad.png",
              filter: "sepia(100%) saturate(400%) hue-rotate(-30deg) brightness(150%)"
            },
            10: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/48938c55b2fb83642a842793bf5e901e.png",
              filter: "sepia(100%) saturate(0%) hue-rotate(0deg) contrast(90%) brightness(80%)"
            },
            11: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/ef43e177f857e08b942dacb06f0177a6.png",
              filter: "sepia(100%) saturate(150%) hue-rotate(-120deg) brightness(80%) contrast(140%)"     
            },
            12: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/7f43773694f331aff487adfba025f856.png",
              filter: "sepia(100%) saturate(150%) hue-rotate(-180deg) brightness(80%) contrast(140%)"
            }, 
            13: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/cf52118894811017b29958bedbd47e0d.png",
              filter: "sepia(100%) saturate(150%) hue-rotate(10deg) brightness(120%) contrast(160%)"    
            },
            14: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/0168281190bc4ef145bb022d7cf1f152.png",
              filter: "sepia(100%) saturate(200%) hue-rotate(-60deg) brightness(80%) contrast(140%)"    
            },
            15: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/6d9a903ca840736244ca167c97219b06.png",
              filter: "sepia(100%) saturate(200%) hue-rotate(-80deg) brightness(100%) contrast(120%)"
            },
            16: {
              triggerImage:"https://customizery.s3.amazonaws.com/bimmerfxx/a0c9d59c82740fb99842509d0056ac38.png",
              filter: "sepia(100%) saturate(0%) hue-rotate(0deg) contrast(120%) brightness(80%)"
            }
          }
        },
        stitchingColor: {
          image: "",
          colorOptions: {
            0: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/3485d285f0ab1fa8af818a80872ff0ac.png",
              filter: "sepia(100%) saturate(0%) hue-rotate(0deg) contrast(100%) brightness(150%)"
            },
            1: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/460d0f4817b6f724409ee5802d0515bf.png",
              filter: "sepia(100%) saturate(0%) hue-rotate(0deg) contrast(100%) brightness(70%)"
            },
            2: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/daa61fe0f7d137eb5747cd57f858db8a.png",
              filter: "sepia(100%) saturate(400%) hue-rotate(300deg)"
            }, 
            3: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/de21e78a099bcdc22ae773c0f5e08d70.png",
              filter: "sepia(100%) saturate(400%) hue-rotate(180deg)"
            },
            4: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/c059f2a9f67a6c0d4475024239b44dd9.png",
              filter: "sepia(100%) saturate(400%) hue-rotate(90deg)"
            },
            5: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/4b743a666ed467cb4d872bff5deae817.png",
              filter: "sepia(100%) saturate(400%) hue-rotate(160deg)"
            },
            6: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/827da4d939bc0067695e60b5a06e5f46.png",
              filter: "sepia(100%) saturate(300%) hue-rotate(10deg)"
            },
            7: {
              triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/f7211c4f69469a4c5aed7b34ddb8fdd6.png",
              filter: "sepia(100%) saturate(300%) hue-rotate(90deg)"
            }
          }
        },
        topStripOptions: {
          0: {
            triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/478975fed26f8130f7d5a0334ea27a91.png",
            image: "",
            image2: ""
          },
          1: {
            triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/7badaa656928cf8634b5dfe1fc20ade2.png",
            image: "",
            image2: ""
          },
          2: {
            triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/fc4d322a6c2b84d3ef1bbd7aaa9d1261.png",
            image: "",
            image2: ""
          },
          3: {
            triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/9d8b2d5b80f3eccdc740a44671d73247.png",
            image: "",
            image2: ""
          },
          4: {
            triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/e5dfea4366a3b79f87ea1e22b254be58.png",
            image: "",
            image2: ""
          },
          5: {
            triggerImage: "https://customizery.s3.amazonaws.com/bimmerfxx/7a3fc338383a2c17fe1587e9efe69090.png",
            image: "",
            image2: ""
          },
          6: {
            triggerImage: "https://customizery.s3.amazonaws.com/zeuscarbon/79743062dd5affbacf4921b69872c58e.png",
            image: "",
            image2: ""
          },
          7: {
            triggerImage: "https://customizery.s3.amazonaws.com/zeuscarbon/dedba9646476f828513f259a7b78fd44.png",
            image: "",
            image2: ""
          }
        }
      }
    },
    /*--------------------- BMW ---------------------*/
    36395951554877: {
      productName: "Full Custom Steering Wheel - BMW G Chassis",
      backgroundOptions: {
        image: "https://i.imgur.com/yy9m8Yf.png",
        colorOptions: {
          0: {
            filter: "saturate(0%) brightness(180%)"
          },
          1: {
            filter: ""
          },
          2: {
            filter: "sepia(100%) saturate(800%) hue-rotate(-40deg)"
          },
          3: {
            filter: "sepia(100%) saturate(200%) hue-rotate(180deg)"
          },
          4: {
            filter: "sepia(0%) saturate(0%) brightness(20%)"
          },
          5: {
            filter: "sepia(100%) saturate(300%) hue-rotate(-10deg) brightness(40%)"
          }
        }
      },
      customOptions: {
        leatherColor: {
          image: "https://i.imgur.com/eN2ahvu.png",
          image2: "https://i.imgur.com/Aynq8mO.png",
          image3: "https://i.imgur.com/rTNr0BU.png",
          triggerImage: "",
          triggerImage2: "",
          triggerImage3: "",
          imageTopBot: "https://i.imgur.com/b6q1PFE.png",
          colorOptions: {}
        },
        carbonFiberStyle: {
          image: "https://i.imgur.com/6O0cGnv.png",
          image2: "https://i.imgur.com/WydLgUy.png",
          colorOptions: {}
        },
        topStripOptions: {
          0: {
            triggerImage: "",
            image: "https://i.imgur.com/NTH3Z6f.png",
            image2: "https://i.imgur.com/OZTRHkV.png"
          },
          1: {
            triggerImage: "",
            image: "https://i.imgur.com/5BwHbXB.png",
            image2: "https://i.imgur.com/CH8KhMI.png"
          },
          2: {
            triggerImage: "",
            image: "",
            image2: ""
          },
          3: {
            triggerImage: "",
            image: "https://i.imgur.com/W2no71r.png",
            image2: "https://i.imgur.com/W5aBpGq.png"
          },
          4: {
            triggerImage: "",
            image: "https://i.imgur.com/TaNiLLO.png",
            image2: "https://i.imgur.com/mF1SX57.png"
          },
          5: {
            triggerImage: "",
            image: "https://i.imgur.com/dxBEur0.png",
            image2: "https://i.imgur.com/ahxZ2az.png"
          }
        },
        stitchingColor: {
          image: "https://i.imgur.com/oiDgHXk.png",
          colorOptions: {}
        }
      }
    },
    32302180729149: {
      productName: "Full Custom Steering Wheel - BMW F Chassis",
      backgroundOptions: {
        image: "https://i.imgur.com/tbqqUHB.png",
        colorOptions: {}
      },
      customOptions: {
        leatherColor: {
          image: "https://i.imgur.com/58KZehh.png",
          imageTopBot: "https://i.imgur.com/5uhG2Ne.png",
          colorOptions: {}
        },
        carbonFiberStyle: {
          image: "https://i.imgur.com/9j33sXX.png",
          image2: "https://i.imgur.com/rC3wDGo.png",
          colorOptions: {}
        },
        topStripOptions: {
          0: {
            triggerImage: "",
            image: "https://i.imgur.com/ZvLuKta.png",
            image2: "https://i.imgur.com/ZvLuKta.png"
          },
          1: {
            triggerImage: "",
            image: "https://i.imgur.com/iGoEgoK.png",
            image2: "https://i.imgur.com/iGoEgoK.png"
          },
          2: {
            triggerImage: "",
            image: "",
            image2: ""
          },
          3: {
            triggerImage: "",
            image: "https://i.imgur.com/7KCP9iX.png",
            image2: "https://i.imgur.com/7KCP9iX.png"
          },
          4: {
            triggerImage: "",
            image: "https://i.imgur.com/tSuAP5L.png",
            image2: "https://i.imgur.com/tSuAP5L.png"
          },
          5: {
            triggerImage: "",
            image: "https://i.imgur.com/lTnKF6q.png",
            image2: "https://i.imgur.com/lTnKF6q.png"
          }
        },
        stitchingColor: {
          image: "https://i.imgur.com/JmXNgmx.png",
          colorOptions: {}
        }
      }
    },
    32302136099133: {
      productName: "Full Custom Steering Wheel - BMW E Chassis",
      backgroundOptions: {
        image: "https://i.imgur.com/0YoxqtR.png",
        colorOptions: {}
      },
      customOptions: {
        leatherColor: {
          image: "https://i.imgur.com/s1HdOMN.png",
          imageTopBot: "https://i.imgur.com/ipWOecq.png",
          colorOptions: {}
        },
        carbonFiberStyle: {
          image: "https://i.imgur.com/8CaNVIe.png",
          image2: "https://i.imgur.com/VnIfpPu.png",
          colorOptions: {}
        },
        topStripOptions: {
          0: {
            triggerImage: "",
            image: "https://i.imgur.com/kNxU1Au.png",
            image2: "https://i.imgur.com/UVwFJoY.png"
          },
          1: {
            triggerImage: "",
            image: "https://i.imgur.com/JX5fa4U.png",
            image2: "https://i.imgur.com/a1uVisT.png"
          },
          2: {
            triggerImage: "",
            image: "",
            image2: ""
          },
          3: {
            triggerImage: "",
            image: "https://i.imgur.com/KP3wJBj.png",
            image2: "https://i.imgur.com/CMjoQgu.png"
          },
          4: {
            triggerImage: "",
            image: "https://i.imgur.com/nJV1yYt.png",
            image2: "https://i.imgur.com/iKS6Xdg.png"
          },
          5: {
            triggerImage: "",
            image: "https://i.imgur.com/LnnkTtM.png",
            image2: "https://i.imgur.com/O1nuNNl.png"
          }
        },
        stitchingColor: {
          image: "https://i.imgur.com/GozmH8D.png",
          colorOptions: {}
        }
      }
    },
    46388034404720: {
      productName: "Full Custom Steering Wheel - BMW 2025 LCI Style",
      backgroundOptions: {
        image: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_2.png",
        coverImage: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_1.png",
        colorOptions: {
          0: {
            filter: "saturate(0%) brightness(180%)"
          },
          1: {
            filter: ""
          },
          2: {
            filter: "sepia(100%) saturate(800%) hue-rotate(-40deg)"
          },
          3: {
            filter: "sepia(100%) saturate(200%) hue-rotate(180deg)"
          },
          4: {
            filter: "sepia(0%) saturate(0%) brightness(20%)"
          },
          5: {
            filter: "sepia(100%) saturate(300%) hue-rotate(-10deg) brightness(40%)"
          }
        }
      },
      customOptions: {
        leatherColor: {
          image: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_3.png",
          image2: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_4.png",
          image3: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_6.png",
          triggerImage: "",
          triggerImage2: "",
          triggerImage3: "",
          imageTopBot: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_11.png",
          imageTopBot2: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_5.png",
          imageTopBot3: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_7.png",
          colorOptions: {}
        },
        carbonFiberStyle: {
          image: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_9.png",
          image2: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_10.png",
          colorOptions: {}
        },
        topStripOptions: {
          0: {
            triggerImage: "",
            image: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_12.png",
            image2: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_12.png"
          },
          1: {
            triggerImage: "",
            image: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_13.png",
            image2: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_13.png"
          },
          2: {
            triggerImage: "",
            image: "",
            image2: ""
          },
          3: {
            triggerImage: "",
            image: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_14.png",
            image2: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_14.png"
          },
          4: {
            triggerImage: "",
            image: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_15.png",
            image2: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_15.png"
          },
          5: {
            triggerImage: "",
            image: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_16.png",
            image2: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_16.png"
          },
          6: {
            triggerImage: "",
            image: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_17.png",
            image2: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_17.png"
          },
          7: {
            triggerImage: "",
            image: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_18.png",
            image2: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_18.png"
          }
        },
        stitchingColor: {
          image: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/LCIStyleWheel_Customizer_8.png",
          colorOptions: {}
        }
      }
    },
    /*--------------------- Audi ---------------------*/
    39972169187645: {
      productName: "Audi R8 / TTRS Style - Full Custom Steering Wheel",
      backgroundOptions: {
        image: "",
        colorOptions: {}
      },
      customOptions: {
        leatherColor: {
          image: "https://i.imgur.com/dOybvuu.png",
          imageTopBot: "",
          colorOptions: {}
        },
        carbonFiberStyle: {
          image: "https://i.imgur.com/NVj6IQD.png",
          image2: "",
          colorOptions: {}
        },
        stitchingColor: {
          image: "",
          colorOptions: {}
        }
      }
    },
    36465849401661: {
      productName: "Audi A / S / RS Style (1st Gen) - Full Custom Steering Wheel",
      backgroundOptions: {
        image: "",
        colorOptions: {}
      },
      customOptions: {
        leatherColor: {
          image: "https://i.imgur.com/ise0W5O.png",
          imageTopBot: "",
          colorOptions: {}
        },
        carbonFiberStyle: {
          image: "https://i.imgur.com/JqTi0Ob.png",
          image2: "",
          colorOptions: {}
        },
        stitchingColor: {
          image: "",
          colorOptions: {}
        }
      }
    },
    36464525410621: {
      productName: "Audi Q Style - Full Custom Steering Wheel ",
      backgroundOptions: {
        image: "",
        colorOptions: {}
      },
      customOptions: {
        leatherColor: {
          image: "https://i.imgur.com/lHHkgbp.png",
          imageTopBot: "",
          colorOptions: {}
        },
        carbonFiberStyle: {
          image: "https://i.imgur.com/jyshhF0.png",
          image2: "",
          colorOptions: {}
        },
        stitchingColor: {
          image: "",
          colorOptions: {}
        }
      }
    },
    40036807115069: {
      productName: "Audi RS6 / RS7 / RSQ8 Style - Full Custom Steering Wheel",
      backgroundOptions: {
        image: "",
        colorOptions: {}
      },
      customOptions: {
        leatherColor: {
          image: "https://i.imgur.com/VrbQLXn.png",
          imageTopBot: "",
          colorOptions: {}
        },
        carbonFiberStyle: {
          image: "https://i.imgur.com/7upBK0o.png",
          image2: "",
          colorOptions: {}
        },
        stitchingColor: {
          image: "",
          colorOptions: {}
        }
      }
    },
    36464518267197: {
      productName: "Audi RS Style - Full Custom Steering Wheel",
      backgroundOptions: {
        image: "",
        colorOptions: {}
      },
      customOptions: {
        leatherColor: {
          image: "https://i.imgur.com/wXBtKVs.png",
          imageTopBot: "",
          colorOptions: {}
        },
        carbonFiberStyle: {
          image: "https://i.imgur.com/GU3AixQ.png",
          image2: "",
          colorOptions: {}
        },
        stitchingColor: {
          image: "",
          colorOptions: {}
        }
      }
    },
    /*--------------------- Mercedes ---------------------*/
    39972162994493: {
      productName: "Mercedes Benz 2021 AMG Performance Style - Full Custom Steering Wheel",
      backgroundOptions: {
        image: "",
        colorOptions: {}
      },
      customOptions: {
        leatherColor: {
          image: "https://i.imgur.com/8Z72hBy.png",
          imageTopBot: "",
          colorOptions: {}
        },
        carbonFiberStyle: {
          image: "https://i.imgur.com/K1ZRb3y.png",
          image2: "",
          colorOptions: {}
        },
        stitchingColor: {
          image: "",
          colorOptions: {}
        }
      }
    },
    36464973152573: {
      productName: "Mercedes Benz 2017 AMG Performance Style - Full Custom Wheel",
      backgroundOptions: {
        image: "",
        colorOptions: {}
      },
      customOptions: {
        leatherColor: {
          image: "https://i.imgur.com/GaiCzdn.png",
          imageTopBot: "",
          colorOptions: {}
        },
        carbonFiberStyle: {
          image: "https://i.imgur.com/FyZTkBy.png",
          image2: "",
          colorOptions: {}
        },
        stitchingColor: {
          image: "",
          colorOptions: {}
        }
      }
    },
    39995614953789: {
      productName: "Mercedes Benz 2020 AMG Performance Style - Full Custom Steering Wheel",
      backgroundOptions: {
        image: "",
        coverImage: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/MBAMG2020Wheel_Customizer_1.webp",
        colorOptions: {
        }
      },
      customOptions: {
        leatherColor: {
          image: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/MBAMG2020Wheel_Customizer_2.webp",
          image2: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/MBAMG2020Wheel_Customizer_7.webp",
          image3: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/MBAMG2020Wheel_Customizer_9.webp",
          triggerImage: "",
          triggerImage2: "",
          triggerImage3: "",
          imageTopBot: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/MBAMG2020Wheel_Customizer_5.webp",
          imageTopBot2: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/MBAMG2020Wheel_Customizer_8.webp",
          imageTopBot3: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/MBAMG2020Wheel_Customizer_6.webp",
          colorOptions: {}
        },
        carbonFiberStyle: {
          image: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/MBAMG2020Wheel_Customizer_3.webp",
          image2: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/MBAMG2020Wheel_Customizer_4.webp",
          colorOptions: {}
        },
        topStripOptions: {
          0: {
            triggerImage: "",
            image: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/MBAMG2020Wheel_Customizer_11.webp",
            image2: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/MBAMG2020Wheel_Customizer_11.webp"
          },
          1: {
            triggerImage: "",
            image: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/Mercedes-Benz-2020-AMG-Performance-Style-Full-Custom-Steering-Wheel-12.webp",
            image2: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/Mercedes-Benz-2020-AMG-Performance-Style-Full-Custom-Steering-Wheel-12.webp"
          },
          2: {
            triggerImage: "",
            image: "",
            image2: ""
          },
          3: {
            triggerImage: "",
            image: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/Mercedes-Benz-2020-AMG-Performance-Style-Full-Custom-Steering-Wheel-13.webp",
            image2: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/Mercedes-Benz-2020-AMG-Performance-Style-Full-Custom-Steering-Wheel-13.webp"
          },
          4: {
            triggerImage: "",
            image: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/Mercedes-Benz-2020-AMG-Performance-Style-Full-Custom-Steering-Wheel-14.webp",
            image2: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/Mercedes-Benz-2020-AMG-Performance-Style-Full-Custom-Steering-Wheel-14.webp"
          },
          5: {
            triggerImage: "",
            image: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/Mercedes-Benz-2020-AMG-Performance-Style-Full-Custom-Steering-Wheel-15.webp",
            image2: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/Mercedes-Benz-2020-AMG-Performance-Style-Full-Custom-Steering-Wheel-15.webp"
          }
        },
        stitchingColor: {
          image: "https://cdn.shopify.com/s/files/1/0684/7250/4637/files/MBAMG2020Wheel_Customizer_10.webp",
          colorOptions: {}
        }
      }
    },
    /*--------------------- Porsche ---------------------*/
    36465012506941: {
      productName: "Porsche 911 992 Style - Full Custom Steering Wheel",
      backgroundOptions: {
        image: "",
        colorOptions: {}
      },
      customOptions: {
        leatherColor: {
          image: "https://i.imgur.com/h4aWA3H.png",
          imageTopBot: "",
          colorOptions: {}
        },
        carbonFiberStyle: {
          image: "https://i.imgur.com/vdafkDf.png",
          image2: "",
          colorOptions: {}
        },
        stitchingColor: {
          image: "",
          colorOptions: {}
        }
      }
    },
    36465017159997: {
      productName: "Porsche Cayenne 2011 - 2014 Style Full Custom Steering Wheel",
      backgroundOptions: {
        image: "",
        colorOptions: {}
      },
      customOptions: {
        leatherColor: {
          image: "https://i.imgur.com/awYcopb.png",
          imageTopBot: "",
          colorOptions: {}
        },
        carbonFiberStyle: {
          image: "https://i.imgur.com/hGjS38l.png",
          image2: "",
          colorOptions: {}
        },
        stitchingColor: {
          image: "",
          colorOptions: {}
        }
      }
    },
    36465020567869: {
      productName: "Porsche Cayenne Style - Full Custom Steering Wheel",
      backgroundOptions: {
        image: "",
        colorOptions: {}
      },
      customOptions: {
        leatherColor: {
          image: "https://i.imgur.com/5RthmOB.png",
          imageTopBot: "",
          colorOptions: {}
        },
        carbonFiberStyle: {
          image: "https://i.imgur.com/jNYOCJN.png",
          image2: "",
          colorOptions: {}
        },
        stitchingColor: {
          image: "",
          colorOptions: {}
        }
      }
    },
    36465024598333: {
      productName: "Porsche Macan Style - Full Custom Steering Wheel",
      backgroundOptions: {
        image: "",
        colorOptions: {}
      },
      customOptions: {
        leatherColor: {
          image: "https://i.imgur.com/5RthmOB.png",
          imageTopBot: "",
          colorOptions: {}
        },
        carbonFiberStyle: {
          image: "https://i.imgur.com/jNYOCJN.png",
          image2: "",
          colorOptions: {}
        },
        stitchingColor: {
          image: "",
          colorOptions: {}
        }
      }
    },
  /*--------------------- Maserati ---------------------*/
    36464952181053: {
      productName: "Maserati Base Style - Full Custom Steering Wheel",
      backgroundOptions: {
        image: "",
        colorOptions: {}
      },
      customOptions: {
        leatherColor: {
          image: "https://i.imgur.com/Q5OOJD0.png",
          imageTopBot: "",
          colorOptions: {}
        },
        carbonFiberStyle: {
          image: "https://i.imgur.com/4l25kzI.png",
          image2: "",
          colorOptions: {}
        },
        stitchingColor: {
          image: "",
          colorOptions: {}
        }
      }
    },
    36464953196861: {
      productName: "Maserati Granturismo Style - Full Custom Steering Wheel",
      backgroundOptions: {
        image: "",
        colorOptions: {}
      },
      customOptions: {
        leatherColor: {
          image: "https://i.imgur.com/pm7jlZa.png",
          imageTopBot: "",
          colorOptions: {}
        },
        carbonFiberStyle: {
          image: "https://i.imgur.com/HhAuIyn.png",
          image2: "",
          colorOptions: {}
        },
        stitchingColor: {
          image: "",
          colorOptions: {}
        }
      }
    },
  /*--------------------- Dodge ---------------------*/
    36464554737981: {
      productName: "Dodge Challenger Srt Style Full Custom Steering Wheel",
      backgroundOptions: {
        image: "",
        colorOptions: {}
      },
      customOptions: {
        leatherColor: {
          image: "https://i.imgur.com/P7f5v3j.png",
          imageTopBot: "",
          colorOptions: {}
        },
        carbonFiberStyle: {
          image: "https://i.imgur.com/OXRdfpR.png",
          image2: "",
          colorOptions: {}
        },
        stitchingColor: {
          image: "",
          colorOptions: {}
        }
      }
    },
    36464564699453: {
      productName: "Dodge Challenger Style - Full Custom Steering Wheel",
      backgroundOptions: {
        image: "",
        colorOptions: {}
      },
      customOptions: {
        leatherColor: {
          image: "https://i.imgur.com/pc46pzT.png",
          imageTopBot: "",
          colorOptions: {}
        },
        carbonFiberStyle: {
          image: "https://i.imgur.com/XmDJAcW.png",
          image2: "",
          colorOptions: {}
        },
        stitchingColor: {
          image: "",
          colorOptions: {}
        }
      }
    }
  };